console.log("QUIZ JS IS RUNNING");

// Wait until the quiz elements actually exist
function waitForQuizElements() {
  const intro = document.getElementById("quiz-intro");
  const startBtn = document.getElementById("start-quiz-btn");
  const quiz = document.getElementById("quiz-container");
  const submitBtn = document.getElementById("submit-quiz");

  if (!intro || !startBtn || !quiz || !submitBtn) {
    console.log("Quiz elements not ready yet… retrying");
    setTimeout(waitForQuizElements, 100);
    return;
  }

  console.log("Quiz elements found — initializing quiz");

  // START QUIZ
  startBtn.addEventListener("click", () => {
    intro.style.display = "none";
    quiz.style.display = "block";
  });

  // SUBMIT QUIZ
  submitBtn.addEventListener("click", function () {
    const questions = document.querySelectorAll(".question-block");
    let score = 0;
    let resultsHTML = "<h2>Your Results</h2>";

    questions.forEach((q, index) => {
      const radios = q.querySelectorAll("input[type='radio']");
      let userCorrect = false;
      let correctAnswerText = "";

      radios.forEach(r => {
        if (r.dataset.correct === "true") {
          correctAnswerText = r.parentNode.textContent.trim();
        }
        if (r.checked && r.dataset.correct === "true") {
          userCorrect = true;
          score++;
        }
      });

      if (userCorrect) {
        q.classList.add("correct");
      } else {
        q.classList.add("incorrect");
      }

      // Get the actual question text
      const questionText = q.querySelector("h3").textContent.trim();

      // Build results block
      resultsHTML += `
        <div class="result-item">
          <h3>${questionText}</h3>
          <p>${userCorrect ? "✔ Correct" : "✘ Incorrect"}</p>

          ${
            userCorrect
              ? `<div class="correct-answer-box-correct">
                   Correct answer: <strong>${correctAnswerText}</strong>
                 </div>`
              : `<div class="correct-answer-box">
                   Correct answer: <strong>${correctAnswerText}</strong>
                 </div>`
          }
        </div>
      `;
    });

    resultsHTML += `<h3>Total Score: ${score} / ${questions.length}</h3>`;
    resultsHTML += `<button id="share-score-btn">Share Your Score</button>`;

    const resultsDiv = document.getElementById("quiz-results");
    resultsDiv.innerHTML = resultsHTML;
    resultsDiv.style.display = "block";

    // SHARE SCORE
    document.getElementById("share-score-btn").addEventListener("click", () => {
      const shareText = `I scored ${score} out of ${questions.length} on the Pacific Fly Fishers Quiz!`;
      const shareUrl = window.location.href;

      if (navigator.share) {
        navigator.share({
          title: "Pacific Fly Fishers Quiz",
          text: shareText,
          url: shareUrl
        });
      } else {
        alert("Sharing is not supported on this device.");
      }
    });
  });
}

// Start checking for quiz elements
waitForQuizElements();
